export type CustomerDetailsHeaderTranslation = {
  button: {
    addContactInfo: string;
    addProcess: string;
    edit: string;
  };
};

export const customerDetailsHeaderTranslation: CustomerDetailsHeaderTranslation = {
  button: {
    addContactInfo: 'Dodaj dane kontaktowe',
    addProcess: 'Utwórz process',
    edit: 'Edytuj',
  },
};
